// skipLinks.js

/**
 * Initialize Skip Links
 * Adds click event listeners to skip links to set focus on target elements.
 *
 * @param {string} linkSelector - Selector for the skip links (e.g., '.skip-link')
 */
export function initSkipLinks(linkSelector = '.skip-link') {
	
	const skipLinks = document.querySelectorAll(linkSelector);

	skipLinks.forEach(link => {
		link.addEventListener('click', function(e) {
			const targetId = this.getAttribute('href').substring(1); // Get the ID without the '#'
			const targetElement = document.getElementById(targetId);
			
			if (targetElement) {
				e.preventDefault(); // Prevent default anchor click behavior
				targetElement.setAttribute('tabindex', '-1'); // Make it focusable
				targetElement.focus(); // Set focus to the target element
			}
		});
	});
}
